import { MODAL_CALCULATOR_PROPS } from 'src/modules/user-input/components/FlowCalculatorModals.tsx';
import { DropdownField } from 'src/modules/common/components/DropdownField/DropdownField.tsx';
import { authorityValues } from 'src/modules/user-input/calcMaxDP/authorityValues.ts';
import { useEffect, useMemo, useReducer } from 'react';
import { reducer } from 'src/modules/user-input/calcMaxDP/reducer.ts';
import { initialState } from 'src/modules/user-input/calcMaxDP/initialState.ts';
import { DecimalField } from 'src/modules/common/components/DecimalField/DecimalField.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { UnitSelector } from 'src/modules/user-input/components/UnitSelector.tsx';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { targetUnits } from 'src/modules/user-input/targetUnits.ts';
import { calcMaxDp } from 'src/modules/user-input/calcMaxDP/calcMaxDp.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { CalculatorModalLayout } from 'src/modules/common/layouts/CalculatorModalLayout.tsx';
import {
    CalculatorModalMainSection,
} from 'src/modules/common/components/CalculatorModalMainSection/CalculatorModalMainSection.tsx';
import { Units } from 'uom-units';
import { numberFormatter } from 'src/utils/numberFormatter.ts';
import { CalcKindEnum } from 'shared/enums/CalcKindEnum';

export const CalcMaxDP = ({
    handleModalValueChange,
    currentLocale,
    allowedUnits,
    targetUnit,
    title,
    kind,
}: MODAL_CALCULATOR_PROPS) => {
    const [state, dispatch] = useReducer(
        reducer,
        {
            ...initialState,
            dpmvUnit: kind === CalcKindEnum.Steam ? Units.Bar : targetUnits.dpmv,
        },
    );
    const dpv100 = useMemo(() => convert(
        calcMaxDp(
            convert(state.dpmv, state.dpmvUnit, targetUnits.dpmv),
            state.pv,
        ),
        Units.KiloPascal,
        targetUnit,
    ), [state, targetUnit]);

    useEffect(() => {
        handleModalValueChange(dpv100);
    }, [dpv100, handleModalValueChange]);
    return (
        <CalculatorModalLayout>
            <CalculatorModalMainSection
                title={title}
                unit={targetUnit.name}
                result={numberFormatter(dpv100, currentLocale)}
                onClick={() => {
                    dispatch({ type: 'reset' });
                }}
            >
                <DropdownField
                    options={authorityValues}
                    selectedValue={state.pv}
                    onChange={(payload) => {
                        dispatch({ type: 'pv_change', payload });
                    }}
                >
                    <I18n messageId={MESSAGES.pv}/>
                </DropdownField>
                <DecimalField
                    name="dpmv"
                    inputSize="lg"
                    labelText={MESSAGES.DPMV}
                    value={state.dpmv}
                    endAdornment={(
                        <UnitSelector
                            selected={state.dpmvUnit.name}
                            values={kind === CalcKindEnum.Steam ? [allowedUnits.dpmv[1]] : allowedUnits.dpmv}
                            onChange={(payload) => {
                                dispatch({ type: 'dpmv_unit', payload });
                            }}
                        />
                    )}
                    currentLocale={currentLocale}
                    onValueChange={(payload) => {
                        dispatch({
                            type: 'dpmv_change',
                            payload,
                        });
                    }}
                    autoComplete="off"
                />
            </CalculatorModalMainSection>
        </CalculatorModalLayout>
    );
};
